import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { Button, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { useState } from 'react';

//component imports
import ViewLoansAndPayments from '../ViewLoansAndPayments';
import { filterByDuration, filterByStatus } from '../../../assets/loanPanelCalculations';

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };
function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export default function DueLoans({loans, hidePanel, updateLoans}) {
  const [value, setValue] = React.useState(0);
  const [panelHidden, setPanelHidden] = useState()

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const hideAllPanels = (val) => {
    hidePanel(val)
    setPanelHidden(val);
  }

  return (
    <Box sx={{ maxWidth: 900, mt: '10px' }}>
      <Box sx = {{bgcolor: 'background.paper',
        display: panelHidden? 'none': 'flex'}}>
          <Tabs
            value={value}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="secondary tabs example"
            textColor="secondary"
            indicatorColor="secondary"
          >
            <Tab {...a11yProps(0)} label="ALL OVERDUE LOANS" />
            <Tab {...a11yProps(1)} label="0-7 DAYS PAST" />
            <Tab {...a11yProps(2)} label="8-30 DAYS PAST" />
            <Tab {...a11yProps(3)} label="1-3 MONTHS PAST" />
            <Tab {...a11yProps(4)} label="3-6 MONTHS PAST" />
            <Tab {...a11yProps(5)} label="6-12 MONTHS PAST" />
            <Tab {...a11yProps(6)} label="1YEAR+" />
          </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <ViewLoansAndPayments loans={filterByStatus(loans, 'overdue')} 
          loansStatus={'ALL OVERDUE LOANS'}
          hidePanel={hideAllPanels} updateLoans={updateLoans}/>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <ViewLoansAndPayments loans={filterByDuration(filterByStatus(loans, 'overdue'), 0, 7)} 
          loansStatus={'0-7 DAYS OVERDUE LOANS'}
          hidePanel={hideAllPanels} updateLoans={updateLoans}/>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        <ViewLoansAndPayments loans={filterByDuration(filterByStatus(loans, 'overdue'), 8, 30)} 
          loansStatus={'8-30 DAYS OVERDUE LOANS'}
          hidePanel={hideAllPanels} updateLoans={updateLoans}/>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={3}>
        <ViewLoansAndPayments loans={filterByDuration(filterByStatus(loans, 'overdue'), 31, 91)} 
          loansStatus={'1-3 MONTHS OVERDUE LOANS'}
          hidePanel={hideAllPanels} updateLoans={updateLoans}/>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={4}>
        <ViewLoansAndPayments loans={filterByDuration(filterByStatus(loans, 'overdue'), 92, 183)} 
          loansStatus={'3-6 MONTHS OVERDUE LOANS'}
          hidePanel={hideAllPanels} updateLoans={updateLoans}/>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={5}>
        <ViewLoansAndPayments loans={filterByDuration(filterByStatus(loans, 'overdue'), 184, 366)} 
          loansStatus={'6-12 MONTHS OVERDUE LOANS'}
          hidePanel={hideAllPanels} updateLoans={updateLoans}/>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={6}>
        <ViewLoansAndPayments loans={filterByDuration(filterByStatus(loans, 'overdue'), 366)} 
          loansStatus={'1 YEAR+ OVERDUE LOANS'}
          hidePanel={hideAllPanels} updateLoans={updateLoans}/>
      </CustomTabPanel>
    </Box>
  );
}
